import React, { useState, useEffect } from "react";
import FrameImage from "../assets/blog/featuredDefault.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import facebook from "../assets/blog/fb.svg";
import share from "../assets/blog/share.svg";
import twitter from "../assets/blog/twitter.svg";
import whatsapp from "../assets/blog/whatsapp.svg";
import linksvg from "../assets/blog/link.svg";
import usersvg from "../assets/blog/user.svg";
import { format } from "date-fns";
import ScheduleSession from "../components/blog/scheduleSession";


const BlogPost = () => {
  const {id} = useParams();
  const [blog,setBlog] = useState();
  const [recommended, setRecommended] = useState();
  const navigate = useNavigate();

  const fetchData = async () => {
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog/` + id);
    const data = res.data;
    const recc  = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog`, {params:{limit:"7", order:"desc", sortBy:"views", attribute:data?.attributes }})
    console.log("This is blog data: ",recc.data);
    setRecommended(recc.data);
    setBlog(data);
  }

  useEffect(() => {
    fetchData();
    }, []);

  return (
    <div className="w-full flex flex-col bg-white px-6 py-8 lg:px-20 lg:py-16">
      {/* Full width Header and Image */}
      <div>
        <div className="flex gap-2 pb-4">
          <Link to={"/blogs"} className="text-[#999999]">
            Blog Home &gt;
          </Link>
          <p className="text-primary-color">
            Feature Post
          </p>
        </div>
        {/* Header */}
        <div>
          <h1 className="text-transparent line-clamp-2 font-medium	 text-18 sm:text-24 md:text-36 bg-gradient-primary-inverse bg-clip-text">
            {blog?.title}
          </h1>
        </div>
        {/* Image */}
        <div className="w-full rounded-lg border-[0.5px] border-secondary3 px-2 py-6 my-4">
          {
            !!blog?.coverImage ? (
              <img src={blog?.coverImage} alt="Feature Post" className="w-[50%] mx-auto" />
            ) : (
              <img src={FrameImage} alt="Feature Post" className="w-[50%] mx-auto" />
            )
          }
        </div>
        {/* Meta info */}
        <div className="flex items-center justify-between text-[14px]text-[#848383] mt-4">
          <p>
            {!!blog?.date && format(new Date(blog?.date), 'dd MMMM, yyyy')}
          </p>
          <ul className="flex">
            <li className="border-r-[0.5px] border-[#999999] px-3 my-1 mr-1">
              <a href="#">
                <img src={share} alt="shareicon" className="h-5 w-5" />
              </a>
            </li>
            <li className="my-1 px-2 ">
              <a href="#">
                <img src={facebook} alt="fbicon" className="h-5 w-5" />
              </a>
            </li>
            <li className="my-1 px-2 ">
              <a href="#">
                <img src={twitter} alt="twtricon" className="h-5 w-5" />
              </a>
            </li>
            <li className="my-1 px-2 ">
              <a href="#">
                <img src={whatsapp} alt="waicon" className="h-5 w-5" />
              </a>
            </li>
            <li className="my-1 px-2 ">
              <a href="#">
                <img src={linksvg} alt="linkicon" className="h-5 w-5" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Main content alongside Sidebar */}
     <div className="w-full flex flex-col md:flex-row gap-4 py-12 mb-4 ">
          <div className="md:w-3/4">
            <main  dangerouslySetInnerHTML={{__html: blog?.content[0]?.content}}>
            </main>
            <div className="flex flex-wrap gap-4 pt-8 pb-4">
              {blog?.attributes?.map((tag) => (
                <div key={tag} className="rounded-full bg-[#04236B1A] text-primary-color px-6 py-1">
                  # {tag}
                </div>
              ))}
            </div>
            <div className="font-semibold py-4 flex items-center gap-2">
              <div className="p-2 bg-gradient-to-r rounded-[100%] from-[#FF99000D] to-[#04236B0D]">
                <img src={usersvg} alt='usersvg' className="w-4 h-4" />
              </div>
              Post by <span className="text-primary-color">{blog?.createdBy}</span>
            </div>
          </div>
          <aside className="md:w-1/4 relative">
              <div className="w-full border border-[#04236B1A] px-4 py-6 rounded-lg sticky top-28">
                <h2 className="pb-2 text-24">
                  Recommended Posts
                </h2>
                <div className="w-full h-full max-h-[60vh] flex md:flex-col gap-4 overflow-auto">
                  {
                    recommended?.map((reccBlog)=>(
                      blog.id != reccBlog.id && (
                        <article key={reccBlog._id} onClick={()=>navigate("/blogs/"+reccBlog.id)} className="w-3/4 cursor-pointer min-w-[75%] h-full sm:w-full border-[0.5px] rounded-lg border-[#04236B1A] px-4 py-4 flex flex-col justify-between gap-2">
                          <h2 className="line-clamp-2 font-medium	">
                            {reccBlog?.title}
                          </h2>
                          <p className="line-clamp-2 text-14" dangerouslySetInnerHTML={{__html: reccBlog?.content[0]?.content}} />
                          <div className="flex flex-col justify-between items-start text-nowrap sm:font-semibold text-[#999999] xl:flex-row xl:items-center">
                            <p className="max-w-[90%] overflow-clip">
                              {reccBlog?.attributes[0]}
                            </p>
                            <p>
                              {!!reccBlog?.date && format(new Date(reccBlog?.date), 'dd/MM/yyyy')}
                            </p>
                          </div>
                        </article>
                      )
                    ))
                  }
                </div>
              </div>
          </aside>
     </div>
     <ScheduleSession />
    </div>
  );
};

export default BlogPost;
